import SiutsPage from './siuts-page';

export default SiutsPage;